import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
const mapChildrenToNumber = (children) => {
    if (typeof children === 'string') {
        return Number.parseFloat(children);
    }
    return children;
};
export default function NumberFormat({ children, locale, ...options }) {
    const numberFormat = new Intl.NumberFormat(locale, options);
    return _jsx(_Fragment, { children: numberFormat.format(mapChildrenToNumber(children)) });
}
//# sourceMappingURL=number-format.view.js.map